import React from "react";

// reactstrap components
import {Card, CardText, CardBody, CardTitle, Col, Container, Row} from "reactstrap";

// core components

function ExperienceCard() {
  let experienceCard = React.createRef();

  /*React.useEffect(() => {
    if (window.innerWidth < 991) {
      const updateScroll = () => {
        console.log("experience scroll");
        let windowScrollTop = window.pageYOffset / 3;
        experienceCard.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });*/

  return (
    <>
      <div
        style={{
          backgroundPosition: "bottom",
          backgroundImage: "url(" + require("../assets/img/beachNight.jpg") + ")"
          //backgroundImage: "url(https://demo.wpoperation.com/arrival-me/wp-content/uploads/2019/10/bnr1.jpg)"
        }}
        //className="section text-center"
        className="page-header"
        data-parallax={true}
        ref={experienceCard}
      >
        <div className="text-center">
          <Row>
            <Col md="4">
              <Card className="card-plain text-white">
                <h1>
                  10+
                  <br/>
                  <small className="text-white">Years of Experience</small>
                </h1>
              </Card>
            </Col>
            <Col md="4">
              <Card className="card-plain text-white">
                <h1>
                  50+
                  <br/>
                  <small className="text-white">Features Shipped</small>
                </h1>
              </Card>
            </Col>
            <Col md="4">
              <Card className="card-plain text-white">
                <h1>
                  20+
                  <br/>
                  <small className="text-white"> Direct Reports</small>
                </h1>
              </Card>
            </Col>
          </Row></div>
      </div>
    </>
  );
}

export default ExperienceCard;
